import {
  ClassServicesEntry,
  ClassServicesPutEntry,
  ClassServicesResponse,
  Person,
} from '../../mnspro-cloud/api/v2';
import {
  ClassService,
  Student,
} from '../../mnspro-cloud/classbook/services.interfaces';
import { getStartOfDayAsUTC } from '../momentHelper';

export const classServiceResponseToClassService = (
  serviceResponse: ClassServicesResponse,
): ClassService => {
  return {
    end: serviceResponse.end,
    id: serviceResponse.id,
    start: serviceResponse.start,
    students: serviceResponse.affectedUsers.map(personToStudents),
    content: serviceResponse.definition?.description ?? '',
    title: serviceResponse.definition?.fullName ?? '',
    definitionId: serviceResponse.definition?.id,
    groupId: serviceResponse.groupId,
    isActive: !serviceResponse.definition?.isDisabled,
  };
};

const personToStudents = (person: Person): Student => {
  return {
    firstName: person.firstName,
    lastName: person.lastName,
    displayName: person.displayName,
    id: person.id,
  };
};

export const classServiceToClassServiceEntry = (
  classService: ClassService,
): ClassServicesEntry => {
  return {
    affectedUsers: classService.students.map(user => user.id),
    definition: { id: classService.definitionId },
    end: getStartOfDayAsUTC(classService.end),
    start: getStartOfDayAsUTC(classService.start),
    groupId: classService.groupId,
  };
};

export const classServiceToClassServicePutEntry = (
  classService: ClassService,
): ClassServicesPutEntry => {
  return {
    affectedUsers: classService.students.map(user => user.id),
    definition: { id: classService.definitionId },
    start: getStartOfDayAsUTC(classService.start),
    end: getStartOfDayAsUTC(classService.end),
    groupId: classService.groupId,
    id: classService.id,
  };
};
